<ng-content></ng-content>
<div class="phx-tab-indicator" *ngIf="showIndicator" [style.width]="indicatorWidth" [style.transform]="indicatorTransformX" [@slideAnimation]="phxActiveTabIndex"></div>
